"use client"
import {
  PieChart
} from "./chunk-TV5EBXNW.mjs";

// src/components/donut-chart.ts
import { mergeMultiStyle } from "@yamada-ui/core";
var DonutChart = mergeMultiStyle(
  PieChart,
  {
    baseStyle: {
      label: {}
    }
  }
)();

export {
  DonutChart
};
//# sourceMappingURL=chunk-VGLVHZNM.mjs.map